module.exports = __webpack_public_path__ + "static/media/snippet_banned_un.fcf49378.png";